export default __webpack_public_path__ + "static/media/healthscore-icon-good.d808d3f9.svg";